<div class="flex justify-center items-center">
  <div class="flex flex-col">
    <div>
      <pin-create-password [username]="username" [isPasswordlessSetup]="true"></pin-create-password>
    </div>
  </div>
</div>

